import {
  ANOMALY_EXTENSIONS,
  AnomalyApi,
  AnomalyFileType,
} from '@api/twin/AnomalyApi';
import { useTeiaViewerContext } from '@stereograph/teiaviewer';
import {
  useQuery,
} from '@tanstack/react-query';
import { anomalyQueryKeys } from '../query-keys';
import { formatAnomalyFilename } from '../utils/formatAnomalyFileName';

export const useExportAnomaliesQuery = (
  projectId: number,
  anomalyIds: Array<number>,
  urlExportType: AnomalyFileType,
) => {
  const { viewer } = useTeiaViewerContext();
  const client = viewer.twinApiClient;

  return useQuery({
    queryKey: anomalyQueryKeys.export(projectId, urlExportType, anomalyIds),
    queryFn: async () => {
      const searchExportResponse = await AnomalyApi(client).exportAnomalies(
        projectId,
        anomalyIds,
        urlExportType,
      );

      const filename = formatAnomalyFilename(ANOMALY_EXTENSIONS[urlExportType]);

      const blob = await searchExportResponse.blob();

      return {
        fileName: filename,
        blob: blob,
      };
    },
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retryOnMount: false,
    retry: 0,
    enabled: false,
  });
};
